import getNodeDimensions from 'get-node-dimensions'

class Header {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._headerHeight = getNodeDimensions(this._elem).height
        this.lastScrollY = 0
        this._popoutCart = this._elem.querySelector('[data-popout-cart]')
        this._searchForm = this._elem.querySelector('[data-search]')
        this._megaMenuOpen = false
    }

    doScrollCalculations () {
        if (window.scrollY > this.lastScrollY && window.scrollY >= this._headerHeight) {
            // Scrolled down
            if (!this._elem.classList.contains('hide-from-view') && !this._popoutCart.classList.contains('shown')) {
                if (!this._megaMenuOpen) {
                    this.hideHeader()
                }
            }
        } else {
            // Scrolled up
            if (this._elem.classList.contains('hide-from-view')) {
                this.showHeader()
            }
        }

        if (window.scrollY >= this._headerHeight) {
            this._elem.classList.add('fixed')
        }

        if (window.scrollY === 0) {
            this._elem.classList.remove('fixed')
            document.body.classList.add('header-visible')
        }

        this.lastScrollY = window.scrollY
    }

    showHeader () {
        this._elem.classList.remove('hide-from-view')
        document.body.classList.add('header-visible')
        document.dispatchEvent(new Event('header-visible'))
    }

    hideHeader () {
        this._elem.classList.add('hide-from-view')
        if (this._searchForm) {
            this._searchForm.classList.remove('shown')
        }
        document.body.classList.remove('header-visible')
        document.dispatchEvent(new Event('header-hide'))
    }

    onInit () {
        window.addEventListener('scroll', () => {
            this.doScrollCalculations()
        })
        document.addEventListener('popout-cart-shown', () => {
            this.showHeader()
        })
        this.doScrollCalculations()

        document.addEventListener('mega-menu--opened', () => {
            this._megaMenuOpen = true
        })
        document.addEventListener('mega-menu--closed', () => {
            this._megaMenuOpen = false
        })
    }
}

export default Header



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Header.js